<template>
  <b-modal
    id="modal-nomenclatura"
    size="md"
    button-size="sm"
    header-bg-variant="secondary"
    header-text-variant="light"
    header-class=""
    footer-class=""
    modal-class="p-2"
    no-close-on-backdrop
    no-close-on-esc
    centered
  >
    <template v-slot:modal-header="">
      <h5>Nomenclatura duplicada</h5>
    </template>

    <strong>Atenção!</strong> Foi encontrada uma vaga cadastrada com a mesma
    nomenclatura informada. O que você deseja fazer?

    <template v-slot:modal-footer="">
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('modal-nomenclatura')"
      >
        Continuar o cadastro
      </b-button>
      <b-button size="sm" variant="outline-secondary" @click="$emit('sair')">
        Sair do cadastro
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";

@Component
export default class ModalNomenclaturaDuplicada extends mixins(UtilsTS, Vue) {}
</script>
